module.exports = __webpack_public_path__ + "static/media/guyane.f89a8b6a.svg";